import { User } from "./user";

export class TollMessage {
    public id?: string;
    public message?: string;
    public tollId?: string | null;
    public creationUser?: User;
    public creationDate: Date;

    constructor(tollMessage?: TollMessage) {
        this.id = tollMessage?.id;
        this.message = tollMessage?.message;
        this.tollId = tollMessage?.tollId;
        this.creationUser = tollMessage?.creationUser;
        this.creationDate = tollMessage?.creationDate || new Date();
    }
}
